import { withAuth0 } from "@auth0/auth0-react";
import { Component } from "react";
import { connect } from "react-redux";
import CallCard from "../Components/CallCard/CallCard";
import ConversationWidget from "../Components/ConversationWidget/ConversationWidget";
import FilterBar from "../Components/FilterBar";
import {
  API_URL,
  WORKFLOW_FILTER,
  CALLHISTORY_CALL_NUMBER_LIMIT,
} from "../ConstVariable";
import LoaderThreeDot from "../Loader/LoaderThreeDot";
import PleaseWait from "../Loader/Pleasewait.gif";
import OrderDetails from "../OrderDetails/OrderDetails";
import PaginationArrowBar from "../UI/PaginationArrowBar/PaginationArrowBar";

import axios from "axios";
import moment from "moment-timezone";
import "../index.css";
import {
  callRecordFunc,
  centerListCallHistoryFunc,
  centerListFunc,
  clearConversationIdFunc,
  SetError,
  statusListCallHistoryFunc,
} from "../redux-store/actions";
import Template from "../UI/GridTemplate/Template";
import SearchBar from "../Components/searchBar/SearchBar";

class Trashcall extends Component {
  constructor() {
    super();
    this.state = {
      call_list: [],
      Loading: true,
      ApiError:false,
      config_workflow_filter: WORKFLOW_FILTER,
      message: [],
      convmsg: [],
      conversationID: "",
      fetchedOrder: {},
      showAudio: false,
      fromDate: "",
      toDate: "",
      callerId: "",
      callStatus: "",
      CallCenter: "",
      callStatusRecord: [],
      FilterCallRecord: "",
      Search: false,
      ResetCheck: "false",
      ID: "",
      ConversationSearch: "",
      searchClicked: false,
      showTestStatus: false,
      callStatusList: [],
      centerListArr: [],
      call_status_list: "",
      center_list: "",
      CallCardSelect: "",
      Netconnection: null,
      callSourceList: [],
      gotNoOfCalls: 0,
      totalNumberOfCall: 0,
      lastName: "",
      firstName: "",
      dob: "",
      page_no: 0,
      areWeInSearchMode: false,
      date_search_by:"CALL_DATE"
    };
  }

  componentDidMount() {
    const id = this.props.match.params.id;
    this.setState({
      ...this.state,
      ID: id,
    });
  }

  GetAuthToken = async () => {
    const { getAccessTokenSilently } = this.props.auth0;
    const token = await getAccessTokenSilently();
    return token;
  };

  getEarlierDateBeforeToday = (todayDate, number) => {
    var fromDate = todayDate;
    let updatedEarlierDate = fromDate.setDate(fromDate.getDate() - number);
    return updatedEarlierDate;
  };

 ;

  refreshCallList = async (
    applyFilter = false,
    page_no = 0,
    areWeInSearchMode = this.state.areWeInSearchMode
  ) => {
    const token = await this.GetAuthToken();
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
    this.setState({ ...this.state, unconcluded_calls: [], Loading: true, gotNoOfCalls: 0, ApiError:false,});

    var request_data = {
      conversationWorkflow: "",
      seach_query_for: "trashcall",
    };

    if (applyFilter === true || areWeInSearchMode) {
      if (this.state.fromDate !== "" && this.state.toDate !== "") {
        let CheckfromDate = new Date(this.state.fromDate);
        let ChecktoDate = new Date(this.state.toDate);

        if (CheckfromDate.getTime() <= ChecktoDate.getTime()) {
          // console.log("Correct Date range");
        } else {
          // console.log("Wrong Date");
          this.props.SetErrorForDisplay({
            severity: "warning",
            message: "Your from date can not be greater than current date",
          });
          return;
        }
      }
      if (this.state.fromDate !== "" && this.state.toDate === "") {
        this.props.SetErrorForDisplay({
          severity: "warning",
          message: "Please select To date",
        });
        return;
      }
      if (this.state.fromDate === "" && this.state.toDate !== "") {
        this.props.SetErrorForDisplay({
          severity: "warning",
          message: "Please select From date",
        });
        return;
      }
      request_data.start_date = this.state.fromDate;
      request_data.end_date = this.state.toDate;
      request_data.status = this.state.callStatus;
      request_data.conversation_id = this.state.ConversationSearch;
      request_data.caller_id = this.state.callerId;
      request_data.center_id = this.state.CallCenter
        ? this.state.CallCenter
        : [];

      request_data.operator_feedback = this.state.callStatusList
        ? this.state.callStatusList
        : [];
      request_data.initiator_source = this.state.callSourceList;
      request_data.start_date = this.state.fromDate;
      request_data.start_date = this.state.fromDate;
      request_data.start_date = this.state.fromDate;
      request_data.last_name = this.state.lastName;
      request_data.dob = this.state.dob;
      request_data.first_name = this.state.firstName;
      request_data.call_context = this.state.call_context ;
      request_data.date_search_by=this.state.date_search_by


      if (this.state.dob) {
        // console.log("DOB", this.state.dob )
        // let DOB  = this.state.dob.split("/").reverse().join("-");
        // console.log("DOB", new Date(this.state.dob))
        request_data.dob = moment(this.state.dob).format("YYYY-MM-DD");
      }
    }

    this.setState({
      ...this.state,
      call_list: [],
      searchClicked: true,
      Loading: true,
      ApiError:false,
      gotNoOfCalls: 0,
    });

    axios({
      method: "post",
      url: `${API_URL}/oi/api/v3/all-calls?page_no=${page_no}`,
      data: request_data,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      timeout: 60000,
      withCredentials: true
    })
      .then((response) => {
        let headers_data = response.headers;

        this.setState({
          ...this.state,
          call_list: [...response.data],
          Loading: false,
          ApiError:false,
          searchClicked: false,
          totalNumberOfCall: headers_data["x-count"],
          gotNoOfCalls: response.data.length,
        });
        // this.props.callRecordFunc(response.data.length);
      })
      .catch((error) => {
        this.setState({ ...this.state, Loading:false, Netconnection: error.message });
        this.props.SetErrorForDisplay({
          severity: "warning",
          message: error.message,
        });
      });
  };

  dateToStringFunc = (givenDate) => {
    var today = givenDate;
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = yyyy + "/" + mm + "/" + dd;
    return today;
  };

  componentDidMount() {
    this.props.centerListCallHistoryFunc(null);
    this.props.statusListCallHistoryFunc(null);
    this.props.centerListFunc(null);
    this.props.callRecordFunc(null);
    this.props.callRecordFunc(0);
  }

  componentDidUpdate(prevProps, prevState) {
    //When the details update to the redux then we are getting the data of center list

    if (
      prevProps.operatorAssignedCenters.length === 0 &&
      this.props.operatorAssignedCenters.length > 0
    ) {
      this.setState(() => {
        return {
          ...this.state,
          center_list: this.props.operatorAssignedCenters,
        };
      });
    }

    if (this.state.showTestStatus) {
      this.refreshCallList();
      this.setState({ ...this.state, showTestStatus: false });
    }
  }

  InputHandler = (e) => {
    // console.log("EVENT", e.target.value);
    this.setState({
      ...this.state,
      [e.target.name]: e.target.value,
    });
  };

  callSourceListHandler = (list) => {
    this.setState({
      ...this.state,
      callSourceList: list,
    });
  };

  callStatusCodeListHandler = (event) => {
    if (event.target.checked) {
      this.state.callStatusList.push(event.target.value);
    } else {
      let updatedArray = this.state.callStatusList.filter(
        (id) => id !== event.target.value
      );
      this.state.callStatusList = updatedArray;
    }

    this.props.statusListCallHistoryFunc(this.state.callStatusList);
  };

  nextCallHandler = () => {
    const { firstNoOfCalls, secondNoOfcalls } = this.getNoOfCallsRange();

    if (parseInt(secondNoOfcalls) === parseInt(this.state.totalNumberOfCall))
      return;

    this.setState({
      ...this.state,
      call_list: [],
      page_no: this.state.page_no + 1,
    });

    if (this.state.call_list.length === 0) return;

    this.refreshCallList(false, this.state.page_no + 1);

    this.props.clearConversationIdFromRedux();
  };

  previousCallHandler = () => {
    if (!this.state.page_no) return;
    // console.log("this.state.page_no-1",this.state.page_no, parseInt(this.state.page_no)-1)
    this.refreshCallList(false, parseInt(this.state.page_no) - 1);

    this.setState({
      ...this.state,
      page_no: this.state.page_no - 1,
      call_list: [],
    });

    this.props.clearConversationIdFromRedux();
  };

  getNoOfCallsRange = () => {
    let totalNumberOfCall = this.state.totalNumberOfCall;
    let firstNoOfCalls = CALLHISTORY_CALL_NUMBER_LIMIT * this.state.page_no;
    let secondNoOfcalls;
    //At the end of page
    if (totalNumberOfCall - firstNoOfCalls <= CALLHISTORY_CALL_NUMBER_LIMIT) {
      secondNoOfcalls = firstNoOfCalls + (totalNumberOfCall - firstNoOfCalls);
    } else {
      secondNoOfcalls = firstNoOfCalls + CALLHISTORY_CALL_NUMBER_LIMIT;
    }
    //Initial Call list
    if (!this.state.page_no) {
      return {
        firstNoOfCalls: this.state.call_list.length,
        secondNoOfcalls: 0,
      };
    }

    return { firstNoOfCalls: firstNoOfCalls, secondNoOfcalls: secondNoOfcalls };
  };

  searchHandler = (searchData) => {
    this.setState({
      ...this.state,
      SearchClicked: true,
      unconcluded_calls: [],
      areWeInSearchMode: true,
      gotNoOfCalls: 0,
      page_no:0,
      Loading: true,
      ApiError:false,
      fromDate: searchData?.start_date,
      toDate: searchData?.end_date,
      ConversationSearch: "",
      callStatusList: searchData?.operator_feedback,
      callerId: searchData?.caller_id,
      CallCenter: searchData?.center_id,
      callSourceList: searchData?.initiator_source,
      lastName: searchData?.last_name,
      dob: searchData?.dob,
      firstName: searchData?.first_name,
      date_search_by:searchData?.date_search_by,
      call_context:searchData?.call_context
    });
  };
  ResetHandler = () => {
    this.setState({
      ...this.state,
      fromDate: "",
      toDate: "",
      callStatus: "",
      FilterCallRecord: "",
      Search: false,
      callerId: "",
      ResetCheck: "true",
      ConversationSearch: "",
      searchClicked: false,
      callStatusList: [],
      centerListArr: [],
      lastName: "",
      dob: "",
      areWeInSearchMode: false,
      page_no: 0,
      unconcluded_calls: [],
      date_search_by:"CALL_DATE",
    });
    this.props.centerListCallHistoryFunc(null);
    this.props.statusListCallHistoryFunc(null);
  };

  render() {
    // console.log("Call History all Call List", this.state.call_list);

    let showcallRecords = null;

    if (this.state.Loading) {
      showcallRecords = (
        <div
          className="text-center"
          style={{
            marginTop: "45vh",
          }}
        >
          <LoaderThreeDot />
        </div>
      );
    } else {
      showcallRecords = (
        <ul
          className=" nav flex-column"
          style={{
            flex: 1,
            scrollSnapType: "y mandatory",
            textDecoration: "none",
            listStyle: "none",
            padding: "0px",
          }}
          // role="tablist"
        >
          {this.state.searchClicked && this.state.Loading && !this.state.ApiError && (
            <img
              style={{
                marginTop: "30vh",
                width: "200px",
                backgroundColor: "none",
              }}
              src={PleaseWait}
              alt="Please wait ....."
            />
          )}
          {this.state.call_list !== null &&
                        this.state.Loading == false && this.state.call_list.length === 0 && this.state.ApiError && (
                            <div
                                style={{
                                    marginTop: "40vh",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                }}
                            >
                            <p>There is a network problem with your connection. </p> <p> Please check your internet connection and try again later.</p>
                                 </div>
            )}{" "}
            {this.state.call_list !== null &&
            this.state.Loading == false && this.state.call_list.length === 0 &&  !this.state.ApiError &&(
              <div
                style={{
                  marginTop: "40vh",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                <p> Sorry no data found </p> <p> Please try something else </p>{" "}
              </div>
            )}{" "}
          {this.state.call_list !== null &&
            this.state.call_list.length !== 0 &&
            this.state.call_list.map((k, index) => (
              <CallCard
                key={index}
                center_id={k?.center_id}
                conversation_id={k.conversation_id}
                caller_id={k.caller_id}
                center_prefix={k.center_prefix}
                center_name={k.center_name}
                status_code={k.operator_feedback}
                initiate_time={k.initiate_time}
                creation_date_at_center={k.creation_date_at_center}
                call_status={k.call_status}
                call_closed_at_last_state={k.call_closed_at_last_state}

                referral_form_status={k.referral_form_status}
                referral_counter={k.referral_form_request_counter}
                operator_name={k.operator_name}
                operator_nickname={k.operator_nickname}
                watch_list={k.watch_list}
                test_call={k.test_call}
                componentIdentity="callhistory"
                getTokenFunc={this.GetAuthToken}
                initiator_source={k.initiator_source}
                // clientSideMessage={clientSideMessageCallhistory}
                CallCardSelectFunc={(val) =>
                  this.setState({ ...this.state, CallCardSelect: val })
                }
                bot_error={k.bot_error}
                appointment_to_be_booked_manually={
                  k.appointment_to_be_booked_manually
                }
                bp_appointment_id={k.bp_appointment_id}
                is_recording_available={k.is_recording_available}
                ereferral_uid={k.ereferral_uid}
                language_code={k.language_code}
                webbot_conversation_device={k.webbot_conversation_device}
                center_timezone={k.center_timezone}
                server_timezone={k.server_timezone}
                operator_feedback={k.operator_feedback}
                conversation_context={k.conversation_context}
                client_ip={k.client_ip}
              />
            ))}{" "}
        </ul>
      );
    }

   
    const noOfCalls = () => {
      const { firstNoOfCalls, secondNoOfcalls } = this.getNoOfCallsRange();
      if (!secondNoOfcalls) {
        return `1-${firstNoOfCalls}`;
      } else {
        return `${firstNoOfCalls + 1}-${secondNoOfcalls}`;
      }
    };

    return (
      <Template>
        <SearchBar
          callDataHandler={(data) => {
            this.setState({
              ...this.state,
              call_list: [...data?.data],
              gotNoOfCalls: data?.data.length,
              totalNumberOfCall: data?.totalCallCount,
              SearchClicked: false,
              Loading: data?.Loading?data?.Loading:false,
              ApiError:false
            });
          }}
          errorDataHandler={()=>{
            this.setState({
                ...this.state,
                Loading: false,
                ApiError:true
            });
         }}
          gotNoOfCalls={this.state.gotNoOfCalls}
          totalNumberOfCall={this.state.totalNumberOfCall}
          noOfCallsText={noOfCalls}
          componentIdentity="trashcall"
          onSearchClick={(searchData) => {
            this.searchHandler(searchData);
          }}
          onResetClick={() => {
            this.ResetHandler();
          }}
          page_no={0}
        />

        <div>
          <div> {showcallRecords} </div>
          {this.state?.totalNumberOfCall > 100 && (
            <PaginationArrowBar
              page_no={this.state.page_no}
              nextButton={this.nextCallHandler}
              previousButton={this.previousCallHandler}
              getNoOfCallsRange={this.getNoOfCallsRange}
              totalNumberOfCall={this.state.totalNumberOfCall}
            ></PaginationArrowBar>
          )}
        </div>

        <ConversationWidget> </ConversationWidget>
        <OrderDetails
          recordsLoading={this.state.Loading}
          getTokenFunc={this.GetAuthToken}
          fetchedLiveOrder={this.state.fetchedOrder}
          // setTestcall={this.state.showTestStatus}
          showtestcallfunc={(val) =>
            this.setState({ ...this.state, showTestStatus: val })
          }
          onSaveFetchingAllCallList={this.refreshCallList}
          componentIdentity="trashcall"
        />
      </Template>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    errorForDisplay: state.Error,
    conversationId: state.SelectedConversationId,
    reducerStatusCode: state.statusCode,
    reducerOperatorWatchList: state.OperatorWatchlist,
    CallStatusCallHistoryList: state.CallStatusCallHistoryList,
    isInternetDisconnected: state.isInternetDisconnected,
    operatorAssignedCenters: state.operatorAssignedCenters,
    selectedCenterIds: state.CenterListCallHistory,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    SetErrorForDisplay: (payload) => dispatch(SetError(payload)),
    centerListCallHistoryFunc: (data) =>
      dispatch(centerListCallHistoryFunc(data)),
    statusListCallHistoryFunc: (data) =>
      dispatch(statusListCallHistoryFunc(data)),
    callRecordFunc: (data) => dispatch(callRecordFunc(data)),
    centerListFunc: (data) => dispatch(centerListFunc(data)),
    clearConversationIdFromRedux: () => dispatch(clearConversationIdFunc()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuth0(Trashcall));
